// main tools
import { useContext } from 'react'

// context
import { AppContext } from '@centria-ui/contexts/app/context'

export const useApp = () => useContext(AppContext)
